var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.5 243.01-90-51.961c-9.977-5.761-22.5 1.447-22.5 12.99v103.923c0 11.503 12.483 18.774 22.5 12.99l90-51.961c9.964-5.752 10.014-20.2 0-25.981zm-82.5 38.97v-51.96l45 25.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.338 137.561-99.338 49.238v-65.799c0-8.284-6.716-15-15-15h-361c-8.284 0-15 6.716-15 15v270c0 8.284 6.716 15 15 15h361c8.284 0 15-6.716 15-15v-64.978l99.428 48.462c9.949 4.848 21.572-2.403 21.572-13.484v-210c0-11.093-11.679-18.387-21.662-13.439zm-460.338 238.439v-240h331v240zm452-38.998-91-44.354v-72.367l91-45.105z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.483f4acb4a965b004b1d142306a1d4ae.svg";
export { ForwardRef as ReactComponent };